import { ServiceBase } from '../../../../core/services/ServiceBase'
import PostLoginProxy from '../proxies/PostLoginProxy'

class PostLoginService extends ServiceBase {
  getFirstLogin(params) {
    return this.getData(() => PostLoginProxy.getFirstLogin(params))
  }
}

export default new PostLoginService()
